import React from 'react'
import { Configure } from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'
import qs from 'qs'
import { navigate } from '@reach/router'

import InstantSearch from '../../atoms/InstantSearch'
import Container from '../../atoms/Dropdown/Container'
import LocationDropdown from '../Search/LocationDropdown'

import { searchStateToUrl } from '../../helpers'

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY,
)

export default ({ market, submarket, submarkets }) => {
  const onSearchStateChange = ss => {
    navigate('/search/' + searchStateToUrl(ss))
  }

  return <InstantSearch onSearchStateChange={onSearchStateChange} searchClient={searchClient}>
    <Configure analytics clickAnalytics sortFacetValuesBy='alpha' />
    <Container>
      <LocationDropdown attribute='allMarkets' />
    </Container>
  </InstantSearch>
}
